import React from 'react';

class ResumeSinceHeadingRow extends React.Component {

    constructor(props) {
        super();
    }

    render() {

        return (
            <section style={this.props.currStyles.Body.SinceSubSection.Row}>
                <span style={this.props.currStyles.Body.SinceSubSection.Row.Name.Heading}>Skill</span>
                <span style={this.props.currStyles.Body.SinceSubSection.Row.Years.Heading}>Years</span>
            </section>
        );
    }
}

export default ResumeSinceHeadingRow


// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeSinceHeadingRow.js